import React, { useState } from "react";
import styled from "styled-components";
import dummyCover from "../../../assets/images/sm-user.jpg";
import { ImgController } from "../../Scripts/ImgController";
import { useEffect } from "react";
const Wrapper = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   padding-bottom: 16px;
   padding-top: 16px;
   margin-bottom: 48px;
   position: relative;
   .pencil {
      position: absolute;
      background: white;
      padding: 4px;
      bottom: 0;
      right: 0;
      border-radius: 99px;
      cursor: pointer;
   }
   .pencil-small {
      position: absolute;
      background: white;
      padding: 4px;
      bottom: -18px;
      border-radius: 99px;
      scale: 0.7;
      left: 5px;
      cursor: pointer;
   }
   .divider {
      border-top: 1px solid #e5e7eb;
   }
   .hover-effect:hover {
      background: linear-gradient(270deg, rgba(0, 97, 255, 0.2) 0%, rgba(0, 97, 255, 0) 100%);
   }
`;
const ArtistImage = ({ sidebarExpanded }) => {
   const currentPublisher = localStorage.getItem("Current-Publisher");
   const [decoded, setDecoded] = useState({});
   useEffect(() => {
      setDecoded(JSON.parse(currentPublisher));
   }, [currentPublisher]);
   return (
      <Wrapper>
         <div className="relative">
            <div className={`relative duration-400  rounded-full ${sidebarExpanded ? "h-20 w-20" : "h-12.5 w-12.5 border-2 border-white"}  `}>
               {decoded?.cover === "" || decoded?.cover === null ? (
                  <img src={dummyCover} alt="" className="rounded-full" />
               ) : (
                  <ImgController src={decoded?.cover} className="h-full w-full" imgClassName="rounded-full" />
               )}
            </div>
         </div>
         <div className="relative w-full">
            <div className={`pt-3 text-center ${sidebarExpanded ? "" : "hidden"}`}>
               <h4 className="text-white font-bold text-base">{decoded?.name}</h4>
               <h5 className="pt-1 text-white text-xs">{decoded?.email}</h5>
            </div>
         </div>
      </Wrapper>
   );
};

export default ArtistImage;
